var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "internal-page-main-section faq-section-main forum-main col-12"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "MainForum MainForumDetails" }, [
            _c("div", { staticClass: "ForumPage ForumPage0" }, [
              _vm._m(1),
              _vm._v(" "),
              _vm.questionData.id != 0
                ? _c(
                    "div",
                    { staticClass: "ForumListing" },
                    [
                      _c(
                        "div",
                        { staticClass: "ForumQue ForumQueBorderNone" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.questionData.question) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.addNewComment == true
                        ? _c(
                            "div",
                            { staticClass: "mt-3 ForumQue-top-container" },
                            [
                              _c("div", { staticClass: "ForumQueActions" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 paddingleft0" },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userComment,
                                          expression: "userComment"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "userComment",
                                        placeholder: "Write Comment"
                                      },
                                      domProps: { value: _vm.userComment },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.userComment = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "requiredstar" }, [
                                      _vm._v("*")
                                    ]),
                                    _vm._v(" "),
                                    _c("font", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.userCommentError))
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row mt-2 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary hrv-sweep-to-right-blue",
                                          attrs: { id: "addComment" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.addComment(
                                                _vm.questionData.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Submit")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary hrv-sweep-to-right-red",
                                          attrs: { id: "CancelComment" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.clickAddNewComment()
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "ForumQue-top-container" }, [
                        _c("div", { staticClass: "ForumQueActions" }, [
                          _vm.addNewComment == false
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "forum_edit_icon hvr-sweep-to-right-blue",
                                  attrs: {
                                    title: "Comment on this Question",
                                    href: "javascript:void(0);"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.clickAddNewComment()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/static/images/edit_icon.png"
                                    }
                                  }),
                                  _vm._v(
                                    " Comment\n                                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ForumQue-top-container ForumQue-Image-container"
                        },
                        [
                          _vm._l(_vm.questionData.immages, function(
                            imgObj,
                            index
                          ) {
                            return [
                              _c(
                                "a",
                                {
                                  key: "images_" + index,
                                  staticClass: "image-zoom example-image-link",
                                  attrs: {
                                    title: "",
                                    href: imgObj.images_path,
                                    rel: "prettyPhoto[gallery]",
                                    "data-lightbox": "question-images",
                                    "data-title": ""
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: imgObj.images_path }
                                  })
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.questionCommentData, function(ansObj, index) {
                        return [
                          _c(
                            "div",
                            { key: ansObj.id, staticClass: "que-comment" },
                            [
                              _c(
                                "div",
                                {
                                  key: "comment_" + index,
                                  staticClass: "ForumQue-top-container"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(ansObj.created_by))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.utcToLocal(
                                          ansObj.created_at,
                                          "hh:mm A MMM D, YYYY"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(ansObj.comment))])
                                ]
                              )
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: "load_comment_" + _vm.index,
                          staticClass: "ForumQue-Details"
                        },
                        [
                          _c(
                            "section",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.totalComments >
                                    _vm.questionCommentData.length,
                                  expression:
                                    "totalComments > questionCommentData.length"
                                }
                              ],
                              staticClass: "container load_more_container pr-0"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-danger deleteMedia hvr-sweep-to-right-red",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.getComments(
                                        _vm.questionData.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    Load More Comments\n                                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Forum Details")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          {
            staticClass: "mt-3 alert alert-danger",
            staticStyle: { display: "none" },
            attrs: { id: "alertError" }
          },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15043cde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15043cde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumDetails.vue
// module id = null
// module chunks = 